import { Routes } from '@angular/router';

import { UserRouteAccessService } from '../../shared';
import { VideoTutorialComponent } from './video-tutorial.component';
import { VideoTutorialDetailComponent } from './video-tutorial-detail.component';

export const videoTutorialRoute: Routes = [
    {
        path: 'video-tutorial/',
        component: VideoTutorialComponent,
        data: {
            authorities: ['ROLE_ADMIN'],
            pageTitle: 'message.notification'
        },
    },
    {
        path: 'video-tutorial/:id',
        component: VideoTutorialDetailComponent,
        data: {
            authorities: ['ROLE_ADMIN'],
            pageTitle: 'message.notification'
        },
    },

];
